import React from 'react'
import About from './About'
import ManagementBoard from './ManagementBoard'
import Statistika from './Statistika'

const InvestClub = () => {
  return (
    <>
    <section className="investclub ">
        <About/>
        <ManagementBoard/>
        <Statistika/>
    </section>
    </>
  )
}

export default InvestClub
